import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, LoadingSpinner } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import {
  BenefitGroupName,
  LunchSettings,
  SelectBenefitsBar
} from '@epi-shared/components';
import {
  useGetDefaultBenefitGroupsSettingsQuery,
  useGetBenefitGroupDetailsQuery
} from '@epi-api/benefitGroups';
import { MyChoiceBenefit } from '@epi-shared/components/BenefitGroups/SettingsSections/MyChoiceBenefit/MyChoiceBenefit';
import { BenefitType } from '@epi-constants/benefitTypes';
import { IBenefits } from '@epi-models/containers/ManageBenefits';
import { EditBenefitGroupForm } from '@epi-forms/BenefitGroup/EditBenefitGroupFrom';

export const EditBenefitGroup = () => {
  const { t } = useTranslation();
  const { benefitGroupId } = useParams<{ benefitGroupId: string }>();
  const { data: benefitsDefaultSettings, isLoading: isDefaultsLoading } =
    useGetDefaultBenefitGroupsSettingsQuery();

  const { data: groupDetails, isLoading: isGroupLoading } =
    useGetBenefitGroupDetailsQuery(benefitGroupId);

  if (isDefaultsLoading || isGroupLoading) {
    return <LoadingSpinner />;
  }
  if (!benefitsDefaultSettings?.contractedBenefits.length || !groupDetails) {
    return <div>{t('containers.benefit_groups.no_result')}</div>;
  }

  return (
    <EditBenefitGroupForm
      defaultSettings={benefitsDefaultSettings}
      groupDetails={groupDetails}
      groupId={benefitGroupId}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <BenefitGroupName />
        <SelectBenefitsBar
          contractedBenefits={benefitsDefaultSettings.contractedBenefits}
        />
        <LunchSettings defaultSettings={benefitsDefaultSettings} />
        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={3} mt={1}>
          {benefitsDefaultSettings?.contractedBenefits.map(
            ({ benefitType, maxAmount, minAmount }) =>
              benefitType !== BenefitType.Lunch ? (
                <MyChoiceBenefit
                  benefitName={benefitType as IBenefits}
                  maxAmounts={[maxAmount, minAmount]}
                  key={`myChoiceBenefit-${benefitType}`}
                />
              ) : null
          )}
        </Box>
      </Box>
    </EditBenefitGroupForm>
  );
};
